<template>
  <template v-if="editableMode">
    <tr class="font-bold">
      <th class="align-middle px-2 text-center border-r border-t-8" rowspan="7" />
      <th class="px-6 py-2 w-3/12 text-left border-r border-t-8">
        NIK
      </th>
      <th class="px-6 py-2 w-4/12 text-left border-r border-t-8">
        Nama
      </th>
      <th class="px-6 py-2 w-3/12 text-left border-r border-t-8">
        Usia / Tgl Lahir
      </th>
      <th
        v-if="!disabled"
        class="border-l border-t-8"
        rowspan="7">
        <div class="flex items-center px-6 py-4">
          <button title="Save Changes" @click="store">
            <Icon icon="ic:baseline-save" class="block w-6 h-6 fill-gray-400" />
          </button>
          <button title="Cancel Edit" @click="cancel">
            <Icon icon="ic:baseline-restart-alt" class="block w-6 h-6 fill-gray-400" />
          </button>
        </div>
      </th>
    </tr>
    <tr>
      <td class="border-r border-t">
        <text-input
          v-model="detail.nik"
          class="form-error px-3"
          :error="errors.nik" />
      </td>
      <td class="border-r border-t">
        <text-input
          v-model="detail.name"
          class="form-error px-3"
          :error="errors.name" />
      </td>
      <td class="border-r border-t">
        <div class="flex gap-2 px-3">
          <number-input
            v-model="detail.age"
            class="form-error w-20"
            :error="errors.age" />
          <text-input
            v-model="detail.dob"
            type="date"
            class="form-error flex-1"
            :error="errors.dob" />
        </div>
      </td>
    </tr>
    <tr class="font-bold">
      <th class="px-6 py-2 text-left border-r">
        Jenis Kelamin
      </th>
      <th class="px-6 py-2 text-left border-r">
        Hubungan dengan kepala keluarga
      </th>
      <th class="px-6 py-2 text-left border-r">
        Status
      </th>
    </tr>
    <tr>
      <td class="pb-2 border-r border-t">
        <select-input
          v-model="detail.gender"
          class="form-error px-3"
          :error="errors.gender">
          <option :value="null">
            [Pilih]
          </option>
          <option value="M">
            Laki-Laki
          </option>
          <option value="F">
            Perempuan
          </option>
          <option value="N">
            Non-Biner
          </option>
          <option value="U">
            Tidak Diketahui
          </option>
        </select-input>
      </td>
      <td class="pb-2 border-r border-t">
        <select-input
          v-model="detail.relationship"
          class="form-error px-3"
          :error="errors.relationship">
          <option value="">
            [Pilih]
          </option>
          <option
            v-for="r in relationships"
            :key="r"
            :value="r">
            {{ r }}
          </option>
        </select-input>
      </td>
      <td class="pb-2 border-r border-t">
        <div class="flex flex-col gap-2 px-3 py-2">
          <label v-if="detail.gender === 'F'" class="flex gap-2 items-center text-sm font-normal">
            <input v-model="detail.is_pregnant" type="checkbox">
            Hamil
          </label>
          <span v-else class="text-gray-400">—</span>
        </div>
      </td>
    </tr>
    <tr class="font-bold">
      <th class="px-6 py-2 text-left border-r border-t">
        Disabilitas
      </th>
      <th class="px-6 py-2 text-left border-r border-t">
        Kondisi Medis
      </th>
      <th class="px-6 py-2 text-left border-r border-t">
        Kebutuhan Khusus
      </th>
    </tr>
    <tr>
      <td class="pb-3 border-r border-t">
        <div class="flex flex-wrap gap-2 px-3 py-2">
          <label
            v-for="d in disabilities"
            :key="d.id"
            class="flex gap-1 items-center text-sm font-normal">
            <input
              type="checkbox"
              :checked="hasDisability(d.id)"
              @change="toggleDisability(d)">
            {{ d.name }}
          </label>
        </div>
      </td>
      <td class="pb-3 border-r border-t">
        <text-input
          v-model="medicalText"
          class="form-error px-3"
          placeholder="Pisahkan dengan koma"
          :error="errors.medical_conditions" />
      </td>
      <td class="pb-3 border-r border-t">
        <text-input
          v-model="specialNeedsText"
          class="form-error px-3"
          placeholder="Pisahkan dengan koma"
          :error="errors.special_needs" />
      </td>
    </tr>
    <tr>
      <td class="pb-4 border-r border-t" colspan="3">
        <label class="px-3 text-gray-600 text-sm font-bold">Deskripsi</label>
        <text-input
          v-model="detail.desc"
          class="form-error mt-1 px-3"
          :error="errors.desc" />
      </td>
    </tr>
  </template>
  <template v-else>
    <tr class="font-bold">
      <th class="align-middle px-2 text-center border-r border-t-8" rowspan="7">
        {{ rowIndex }}.
      </th>
      <th class="px-6 py-2 w-3/12 text-left border-r border-t-8">
        NIK
      </th>
      <th class="px-6 py-2 w-4/12 text-left border-r border-t-8">
        Nama
      </th>
      <th class="px-6 py-2 w-3/12 text-left border-r border-t-8">
        Usia
      </th>
      <th
        v-if="!disabled"
        class="py-2 border-l border-t-8"
        rowspan="7">
        <div class="flex items-center px-6 py-4">
          <button title="Edit Member" @click="edit">
            <Icon icon="ic:baseline-edit-note" class="block w-6 h-6 fill-gray-400" />
          </button>
          <button title="Delete Member" @click="destroy">
            <Icon icon="ic:baseline-delete" class="block w-6 h-6 fill-gray-400" />
          </button>
        </div>
      </th>
    </tr>
    <tr>
      <td class="border-r border-t">
        <div class="flex items-center px-6 focus:text-indigo-500">
          {{ assessmentMember.nik || '-' }}
        </div>
      </td>
      <td class="text-right border-r border-t">
        <div class="flex items-center px-6 py-4">
          {{ assessmentMember.name }}
        </div>
      </td>
      <td class="border-r border-t">
        <div class="flex items-center px-6 py-4">
          {{ assessmentMember.age != null ? assessmentMember.age + ' th' : '-' }}
          <span v-if="assessmentMember.dob" class="ml-2 text-gray-400 text-sm">{{ formatDate(assessmentMember.dob) }}</span>
        </div>
      </td>
    </tr>
    <tr class="font-bold">
      <th class="px-6 py-2 text-left border-r">
        Jenis Kelamin
      </th>
      <th class="px-6 py-2 text-left border-r">
        Hubungan dengan kepala keluarga
      </th>
      <th class="px-6 py-2 text-left border-r">
        Status
      </th>
    </tr>
    <tr>
      <td class="border-r border-t">
        <div class="flex items-center px-6">
          {{ genderLabel(assessmentMember.gender) }}
        </div>
      </td>
      <td class="border-r border-t">
        <div class="flex items-center px-6 py-4">
          {{ assessmentMember.relationship }}
        </div>
      </td>
      <td class="border-r border-t">
        <div class="flex items-center px-6 py-4 text-sm">
          <Icon
            v-if="assessmentMember.is_head_of_family"
            icon="mdi:crown"
            class="fill-amber-500 block mr-1 w-4 h-4" />
          <span v-if="assessmentMember.is_head_of_family" class="text-amber-600 font-bold">Kepala Keluarga</span>
          <span v-if="assessmentMember.is_pregnant" :class="assessmentMember.is_head_of_family ? 'ml-2 text-pink-600' : 'text-pink-600'">Hamil</span>
          <span v-if="!assessmentMember.is_head_of_family && !assessmentMember.is_pregnant">-</span>
        </div>
      </td>
    </tr>
    <tr class="font-bold">
      <th class="px-6 py-2 text-left border-r border-t">
        Disabilitas
      </th>
      <th class="px-6 py-2 text-left border-r border-t">
        Kondisi Medis
      </th>
      <th class="px-6 py-2 text-left border-r border-t">
        Kebutuhan Khusus
      </th>
    </tr>
    <tr>
      <td class="border-r border-t">
        <div class="px-6 py-4 text-sm">
          {{ (assessmentMember.disability_types || []).map((d) => d.name).join(', ') || '-' }}
        </div>
      </td>
      <td class="border-r border-t">
        <div class="px-6 py-4 text-sm">
          {{ (assessmentMember.medical_conditions || []).join(', ') || '-' }}
        </div>
      </td>
      <td class="border-r border-t">
        <div class="px-6 py-4 text-sm">
          {{ (assessmentMember.special_needs || []).join(', ') || '-' }}
        </div>
      </td>
    </tr>
    <tr>
      <td class="pb-4 border-r border-t" colspan="3">
        <div class="px-6 py-2 text-gray-500 text-sm">
          <span class="font-bold">Deskripsi:</span> {{ assessmentMember.desc || '-' }}
        </div>
      </td>
    </tr>
  </template>
</template>

<script lang="js">
import { Icon } from '@iconify/vue'
import { ref } from 'vue'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import NumberInput from '@/Shared/NumberInput'
import clone from 'lodash/clone'

export default {
    components: {
        Icon,
        TextInput,
        NumberInput,
        SelectInput,
    },
    props: {
        assessmentMember: Object,
        disabilities: Array,
        errors: Object,
        editableMode: {
            type: Boolean,
            default: false,
        },
        rowIndex: {
            type: Number,
            default: 1,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['destroy:detail', 'cancel', 'save', 'edit:detail'],
    setup (props) {
        const detail = ref(props.assessmentMember)
        const oriData = ref(typeof assessmentMember)

        return {
            detail,
            oriData,
        }
    },
    data () {
        return {
            relationships: [
                'Kepala Keluarga',
                'Istri',
                'Suami',
                'Anak',
                'Orang Tua',
                'Saudara',
                'Lainnya',
            ],
        }
    },
    computed: {
        medicalText: {
            get () {
                return (this.detail.medical_conditions || []).join(', ')
            },
            set (val) {
                this.detail.medical_conditions = val.split(',').map(s => s.trim()).filter(s => s)
            },
        },
        specialNeedsText: {
            get () {
                return (this.detail.special_needs || []).join(', ')
            },
            set (val) {
                this.detail.special_needs = val.split(',').map(s => s.trim()).filter(s => s)
            },
        },
    },
    methods: {
        genderLabel (gender) {
            const labels = { M: 'Laki-Laki', F: 'Perempuan', N: 'Non-Biner', U: 'Tidak Diketahui' }
            return labels[gender] || '-'
        },
        formatDate (dateStr) {
            if (!dateStr) return ''
            const d = new Date(dateStr)
            if (isNaN(d.getTime())) return dateStr
            const dd = String(d.getDate()).padStart(2, '0')
            const mm = String(d.getMonth() + 1).padStart(2, '0')
            const yyyy = d.getFullYear()
            return `${dd}/${mm}/${yyyy}`
        },
        hasDisability (id) {
            return (this.detail.disability_types || []).some(d => d.id === id)
        },
        toggleDisability (d) {
            if (!this.detail.disability_types) {
                this.detail.disability_types = []
            }
            const idx = this.detail.disability_types.findIndex(x => x.id === d.id)
            if (idx >= 0) {
                this.detail.disability_types.splice(idx, 1)
            } else {
                this.detail.disability_types.push({ id: d.id, name: d.name })
            }
        },
        edit () {
            this.oriData = clone(this.assessmentMember)
            this.$emit('edit:detail', this.detail)
        },
        cancel () {
            this.detail = clone(this.oriData)
            this.$emit('cancel')
        },
        store () {
            this.$emit('save', this.detail)
        },
        destroy () {
            if (confirm('Are you sure you want to delete this member?')) {
                this.$emit('destroy:detail', this.assessmentMember.id)
            }
        },
    },
}
</script>
